import { BranchUpdateUseCase } from '../../../../application';

export default class BranchUpdateService {

    async execute(event) {
        const data = await BranchUpdateUseCase(event);
        return data;
    }
}
